/**
 * Import from node_modules
 */
import 'bootstrap/js/src/scrollspy';

/**
 * Import site scripts
 */
import SkipLinkFocusFix from './site/skip-link-focus-fix';
import Menu from './site/menu';
import Sliders from './site/sliders';
import ScrollTo from './site/scrollTo';
// import Styleguide from './site/styleguide';
import Fancybox from './site/fancybox';
import Select2 from './site/select2';
import FormHelpers from './site/formHelpers';
import PerfectScroll from './site/perfectScroll';
import LazyLoading from './site/lazyLoad';
// import LoadMoreBlog from './site/loadMoreBlog';
import equalHeight from './site/equalHeight';
import focusLabel from './site/focusLabel';
import accordion from './site/accordion';
import verticalTab from './site/verticalTab';
import LocationSearch from './site/locationSearch';
import Animations from './site/animations';
import MyAccount from './site/myaccount';
import Checkout from './site/checkout';
import BookingsMyAcc from './site/bookingsMyAcc';
import BookingReorder from './site/bookingReorder';
import ModifyOrder from './site/bookingModify';
import HomepageProducts from './site/homepageProducts';

/**
 * Init site scripts
 */
jQuery(function() {
	Animations.init();
	SkipLinkFocusFix.init();
	// Styleguide.init();
	Menu.init();
	Sliders.init();
	ScrollTo.init();
	Fancybox.init();
	Select2.init();
	FormHelpers.init();
	PerfectScroll.init();
	LazyLoading.init();
	// LoadMoreBlog.init();
	equalHeight.init();
	focusLabel.init();
	accordion.init();
	verticalTab.init();
	LocationSearch.init();
	MyAccount.init();
	Checkout.init();
	BookingsMyAcc.init();
	BookingReorder.init();
	ModifyOrder.init();
	HomepageProducts.init();
});
